import { getAppConfig } from 'app/getConfig';

const suffix = getAppConfig().AUTH_API_CLIENT_URL?.match(/api-auth(-[\w-]+)?\.workbuzz/)?.[1] ?? '';

export const AUTH_TOKEN_COOKIE = `wbAuthToken${suffix}`;

/**
 * Cookie domain scoped to the parent domain of the current host, so the auth token is
 * shared across sibling subdomains (admin/report/survey/login). Derived from the current
 * hostname so it works on any environment domain (workbuzz.com, workbuzzlabs.com, ...).
 * Returns undefined for dotless hosts (e.g. localhost) → host-only cookie in local dev.
 */
export const getAuthTokenCookieDomain = (): string | undefined => {
  const parts = window.location.hostname.split('.');
  return parts.length < 2 ? undefined : `.${parts.slice(-2).join('.')}`;
};
